moya.search = window.moya.search || {};

moya.search = $.extend({}, moya.search, {
	autocompleteSelect: function(event, ui) {
		if (ui.item && ui.item.value.url) {
			window.location = ui.item.value.url;
		}
		else if (ui.item.header) {
			$('#searchForm').submit();
		}
		return false;
	},

	autocompleteRender: function( ul, item ) {
		if (item.header) {
			return $( '<li class="header">' )
				.append('<span class="result__label">' +
					'<span class="result__seeAll">' + item.value + '</span>' +
					'</span>')
				.appendTo( ul );
		}

		var label = item.label;
		if (item.value.types[0] == 'news') {
			label += '<span>(' + item.value.date + ')</span>';
		}

		return $( '<li class="result">' )
			.append('<span class="result__label">' +
			'<span class="result__title">' + label + '</span>' +
			'<span class="result__content">' + item.value.content + '</span>' +
			'</span>')
			.appendTo( ul );
	}
});
